/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Taxonomy_Detail_DescriptionInputs */

const en_directory_taxonomy_detail_description = /** @type {(inputs: Directory_Taxonomy_Detail_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compare the Seek AI products currently published for ${i?.name}.`)
};

const zh_directory_taxonomy_detail_description = /** @type {(inputs: Directory_Taxonomy_Detail_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`对比 Seek AI 当前在${i?.name}下发布的产品。`)
};

/**
* | output |
* | --- |
* | "Compare the Seek AI products currently published for {name}." |
*
* @param {Directory_Taxonomy_Detail_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_description = /** @type {((inputs: Directory_Taxonomy_Detail_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_description(inputs)
	return zh_directory_taxonomy_detail_description(inputs)
});
export { directory_taxonomy_detail_description as "directory.taxonomy_detail.description" }